/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import LoginUser from './LoginUser';
import LoginUserConfig from './LoginUserConfig';

/**
* The LoginResponse model module.
* @module model/LoginResponse
* @version 2020-12-7
*/
export default class LoginResponse {
    /**
    * Constructs a new <code>LoginResponse</code>.
    * ログインレスポンス
    * @alias module:model/LoginResponse
    * @class
    * @param token {String} 認証トークン
    * @param user {module:model/LoginUser} 
    * @param config {module:model/LoginUserConfig} 
    * @param result {module:model/LoginResponse.ResultEnum} 
    */

    constructor(token, user, config, result) {
        
        
        this['token'] = token;
        this['user'] = user;
        this['config'] = config;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>LoginResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoginResponse} obj Optional instance to populate.
    * @return {module:model/LoginResponse} The populated <code>LoginResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoginResponse();
                        
            
            if (data.hasOwnProperty('token')) {
                obj['token'] = ApiClient.convertToType(data['token'], 'String');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = LoginUser.constructFromObject(data['user']);
            }
            if (data.hasOwnProperty('config')) {
                obj['config'] = LoginUserConfig.constructFromObject(data['config']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 認証トークン
    * @member {String} token
    */
    'token' = undefined;
    /**
    * @member {module:model/LoginUser} user
    */
    'user' = undefined;
    /**
    * @member {module:model/LoginUserConfig} config
    */
    'config' = undefined;
    /**
    * @member {module:model/LoginResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
